import React, { useState, useEffect } from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import Inputs from '../Common/Inputs';
import Output from '../Common/Output';
import RandomContent from '../Components/RandomContent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { convertJsonToHtml, downloadHtmlFile } from '../Conversion/JsonHtmlConvertor';

const JsonToHtml = () => {
    const [inputData, setInputData] = useState('');
    const [outputData, setOutputData] = useState('');
    const [isError, setIsError] = useState(false);
    const [fontSize, setFontSize] = useState(14);
    const [inputLnCol, setInputLnCol] = useState({ line: 1, column: 1 });
    const [outputLnCol, setOutputLnCol] = useState({ line: 1, column: 1 });

    useEffect(() => {
        setInputData('');
        setOutputData('');
        setIsError(false);
    }, []);

    const handleConversion = () => {
        try {
            const converted = convertJsonToHtml(inputData);
            setOutputData(converted);
            setIsError(false);
        } catch (err) {
            setOutputData('Invalid JSON format!');
            setIsError(true);
        }
    };

    return (
        <>
            <div>
                <Header />

                <RandomContent />

                {/* Intro Section */}
                <div className="blog-area pb-20">
                    <div className="container-block-fluid">
                        <div className="row justify-content-center">
                            <div className="full-col col-lg-12 col-md-12">
                                <div className="single-blog-inner" data-aos="fade-up" data-aos-duration="2800">
                                    <div className="details">
                                        <h4><a href="#">Convert JSON to HTML</a></h4>
                                        <p>
                                            Looking for a Free JSON to HTML Conversion Online Tool? 
                                            Data Beautifier makes it simple and efficient! Our Best JSON to HTML Converter Online Tool is designed to transform JSON data into a properly formatted HTML structure seamlessly. With our Simple JSON to HTML Converter Tool, you can handle conversions in just a few clicks—no technical expertise required. Whether you’re a developer or a data enthusiast, our Easy JSON to HTML Converter Tool ensures accuracy and speed, saving you valuable time. Accessible anytime, Data Beautifier provides reliable results for free. Simplify your data conversion needs with us today!
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Input / Button / Output Section */}
                <div className="blog-area pb-20">
                    <div className="container-block-fluid">
                        <div className="row justify-content-center">
                            
                            {/* Input Box */}
                            <div className="full-col col-lg-5 col-md-5">
                                <div className="single-blog-inner" data-aos="fade-up" data-aos-duration="2800">
                                    <div className="thumb">
                                        <Inputs
                                            value={inputData}
                                            setValue={(val) => {
                                                setInputData(val);
                                                setIsError(false);
                                            }}
                                            fontSize={fontSize}
                                            setFontSize={setFontSize}
                                            isError={isError}
                                            lineCol={inputLnCol}
                                            setLineCol={setInputLnCol}
                                            readOnly={false}
                                            idPrefix="input"
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Convert Button */}
                            <div
                                className="w3-col m2"
                                style={{
                                    flex: 2,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    gap: '10px',
                                    flexDirection: 'column'
                                }}
                            >
                                <button
                                    className="default-btn icon four"
                                    onClick={handleConversion}
                                >
                                    <i className="ri-exchange-line"></i>
                                    Convert
                                </button>

                                {outputData && !isError && (
                                    <button
                                        className="default-btn icon"
                                        onClick={() => downloadHtmlFile(outputData)}
                                    >
                                        <FontAwesomeIcon icon={faDownload} /> Download HTML
                                    </button>
                                )}
                            </div>

                            {/* Output Box */}
                            <div className="full-col col-lg-5 col-md-5">
                                <div className="single-blog-inner" data-aos="fade-up" data-aos-duration="1200">
                                    <div className="thumb">
                                        <Output
                                            value={outputData}
                                            lineCol={outputLnCol}
                                            setLineCol={setOutputLnCol}
                                            fontSize={fontSize}
                                            setFontSize={setFontSize}
                                            idPrefix="output"
                                            readOnly={true}
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
};

export default JsonToHtml;
